import { useNavigate } from 'react-router-dom';
import { Button } from '@ftdr/blueprint-components-react';
import Path from '@constants/paths';
import React from 'react';
import Modal from './Modal';
import NewOrderAccountFailure from '@components/modal/subcomponents/NewOrderAccountFailure';
import { getCurrentThemeConfig } from '@app/core/theme-config';

const ModalNewOrderAccountFailure = (props) => {
  const navigate = useNavigate();

  const actions = [
    <Button
      key="submit"
      size="medium"
      label="Contact Us"
      onClick={() => navigate(Path.ContactUs)}
      className={getCurrentThemeConfig().modalStyleButton}
      color={getCurrentThemeConfig().modalOkStyleButtonColor}
    />,
  ];

  return (
    <Modal
      isActive={props.isActive}
      onClose={props.onClose}
      heading="Unable to Create New Order"
      actions={actions}
      hideClose={true}
    >
      {props.isActive && <NewOrderAccountFailure />}
    </Modal>
  );
};

export default ModalNewOrderAccountFailure;
